import { Timers } from '@tldraw/utils'

/**
 * A global timer manager.
 *
 * @public
 */
export const tltime = new Timers()
